import React, {useState, useEffect} from 'react'
import * as txApi from '../clients/tx-sls-client'

export const useTournamentDetails = (tournamentId) => {
  const [tournamentDetails, setTournamentDetails] = useState({})

  useEffect(() => {
    if(tournamentDetails.tournamentId !== tournamentId) {
      const extractTotalFish = (totalFish, days) => {
        let total
    
        if(!totalFish) {
          total = [0]
        } else {
          const json = JSON.parse(totalFish)
    
          if(typeof json === 'object') {
            const totalFishArray = json
            total = [...Array(parseInt(days))].map((_, index) => totalFishArray[index + 1])          
          } else {
            total = [json]
          } 
        }
    
        return total
      }

      txApi.getTournamentDetails(tournamentId)
        .then( tourneyDetails => {
          const totalDays = tourneyDetails.marathon_days ? tourneyDetails.marathon_days : 1
          const maxFish = extractTotalFish(tourneyDetails.total_fish, totalDays)
          setTournamentDetails({...tourneyDetails, totalDays, maxFish, tournamentId})
        })
        .catch(error => console.error(`Error retrieving details for tournement id ${tournamentId}`))
    }

  }, [])

  return tournamentDetails
}